/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_OwnerInputs */

const en_role_owner = /** @type {(inputs: Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const es_role_owner = /** @type {(inputs: Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propietario`)
};

const fr_role_owner = /** @type {(inputs: Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriétaire`)
};

const de_role_owner = /** @type {(inputs: Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigentümer`)
};

const id_role_owner = /** @type {(inputs: Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilik`)
};

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const ja_role_owner = en_role_owner;

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const zh_role_owner = en_role_owner;

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const ar_role_owner = en_role_owner;

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const it_role_owner = en_role_owner;

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const ru_role_owner = en_role_owner;

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const pt_role_owner = en_role_owner;

/** @type {(inputs: Role_OwnerInputs) => LocalizedString} */
const ko_role_owner = en_role_owner;

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Role_OwnerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const role_owner = /** @type {((inputs?: Role_OwnerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_OwnerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_owner(inputs)
	if (locale === "es") return es_role_owner(inputs)
	if (locale === "fr") return fr_role_owner(inputs)
	if (locale === "de") return de_role_owner(inputs)
	if (locale === "ja") return ja_role_owner(inputs)
	if (locale === "zh") return zh_role_owner(inputs)
	if (locale === "ar") return ar_role_owner(inputs)
	if (locale === "id") return id_role_owner(inputs)
	if (locale === "it") return it_role_owner(inputs)
	if (locale === "ru") return ru_role_owner(inputs)
	if (locale === "pt") return pt_role_owner(inputs)
	return ko_role_owner(inputs)
});